import React, { Component } from 'react';
import Canvas from './Canvas';
import FloatingMenu from './FloatingMenu';
import Resources from './Resources';
import MenuElement from './MenuElement';

export default class Builder extends Component {
    
	render() {

        let className = 'builder';

        if (!this.props.editing) {
            className += ' is-locked';
        }
        const style = {};
        if (this.props.showTutorial) {
            style.zIndex = 101;
        }

		return (     

            <div className={className}>
                {
                    this.props.editing &&
                    <div className="">
                        <div className="leftbar" style={style}>

                            <FloatingMenu name="Fondos" icon={<span className="btn-green"><i className="icon-fondos"></i></span>} color="green"
                                visible={this.props.menu === 'background'}                               
                                onClick={this.props.onMenuClick.bind(this, 'background')}>
                                
                                <div className="item" onClick={this.props.onBackgroundSelect.bind(this, 'red.png')}><img draggable="false" src="img/thumb-fondo-red.png" alt="Fondo Rojo" role="presentation" /></div>
                                <div className="item" onClick={this.props.onBackgroundSelect.bind(this, 'green.png')}><img draggable="false" src="img/thumb-fondo-green.png" alt="Fondo Verde" role="presentation" /></div>
                                <div className="item" onClick={this.props.onBackgroundSelect.bind(this, 'blue.png')}><img draggable="false" src="img/thumb-fondo-blue.png" alt="Fondo Azul" role="presentation" /></div>

                            </FloatingMenu>

                            <FloatingMenu name="Suelos" icon={<span className="btn-green"><i className="icon-suelos"></i></span>} color="green"
                                visible={this.props.menu === 'ground'}                              
                                onClick={this.props.onMenuClick.bind(this, 'ground')}>
                                <div className="item" onClick={this.props.onGroundSelect.bind(this, 'green.png')}><img draggable="false" src="img/thumb-ground-green.png" alt="Suelo Verde" role="presentation" /></div>
                                <div className="item" onClick={this.props.onGroundSelect.bind(this, 'red.png')}><img draggable="false" src="img/thumb-ground-red.png" alt="Suelo Rojo" role="presentation" /></div>
                                <div className="item" onClick={this.props.onGroundSelect.bind(this, 'yellow.png')}><img draggable="false" src="img/thumb-ground-yellow.png" alt="Suelo Amarillo" role="presentation" /></div>
                            </FloatingMenu>
                        </div>

                        <div className="rightbar">

                            <FloatingMenu name="Construcciones" icon={<span className="btn-yellow"><i className="icon-contrucciones"></i></span>} color="yellow" btnMore={true}
                                visible={this.props.menu === 'buildings'}
                                disabled={!this.props.ground}
                                onShowTutorial={this.props.onShowTutorial.bind(this)}
                                onClick={this.props.onMenuClick.bind(this, 'buildings')}>
                                {Resources.buildings.map((item, key) => {
                                    return <MenuElement 
                                        key={key} 
                                        item={item} 
                                        selected={this.props.selectedMenuElement === item}
                                        onClick={this.props.onMenuElementClick}
                                        {...this.props} />
                                })}
                            </FloatingMenu>

                            <FloatingMenu name="Naturaleza" icon={<span className="btn-yellow"><i className="icon-naturaleza"></i></span>} color="yellow" btnMore={true}
                                visible={this.props.menu === 'nature'}
                                disabled={!this.props.ground}
                                onShowTutorial={this.props.onShowTutorial.bind(this)}
                                onClick={this.props.onMenuClick.bind(this, 'nature')}>
                                {Resources.nature.map((item, key) => {
                                    return <MenuElement 
                                        key={key} 
                                        item={item} 
                                        selected={this.props.selectedMenuElement === item}
                                        onClick={this.props.onMenuElementClick} 
                                        {...this.props} />
                                })}
                            </FloatingMenu>

                           {
                            /*<FloatingMenu name="Personajes" icon={<span className="btn-yellow"><i className="icon-personajes"></i></span>} color="yellow" btnMore={true}
                                visible={this.props.menu === 'characters'}
                                disabled={!this.props.ground}
                                onShowTutorial={this.props.onShowTutorial.bind(this)}
                                onClick={this.props.onMenuClick.bind(this, 'characters')}>
                                {Resources.characters.map((item, key) => {
                                    return <MenuElement 
                                        key={key} 
                                        item={item} 
                                        selected={this.props.selectedMenuElement === item}
                                        onClick={this.props.onMenuElementClick} 
                                        {...this.props} />
                                })}
                            </FloatingMenu>*/
                           } 
                            
                            
                        </div>
                    </div>
                }

				<Canvas {...this.props} />

                    {this.props.saved}
                    <div className="canvas-fake"></div> 
                        <div className={this.props.editing ? 'actions': 'actions is-locked'}>                       
                            {
                                this.props.editing &&
                                    <a className={ (!this.props.ground)? 'btn btn-brand hvr-float-shadow disabled': 'btn btn-brand hvr-float-shadow' } onClick={this.props.onFinishEditingClick}><i className="icon-download" aria-hidden="true"></i> Guarda tu aventura</a>
                                   
                            }
                            {
                                (!this.props.editing && !this.props.saved) &&
                                    <a className={"btn btn-brand hvr-float-shadow" } onClick={this.props.onStartEditingClick}><i className="icon-tools" aria-hidden="true"></i> Vuelve a editar</a>
                            }
                        </div>
                     


			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Builder.js